import { createAsyncThunk, createEntityAdapter, createSlice } from "@reduxjs/toolkit";

import {
    getVogaclosetInvoicesApi,
    exportXeroInvoiceDetailReportApi,
} from "../../../../services/report";


export const getInvoices = createAsyncThunk('report/getInvoices', async (data, { dispatch }) => {
    const response = await getVogaclosetInvoicesApi(data);
    dispatch(setInvoicesData(response.response));
    return response.response;
});

export const exportXeroInvoiceDetailReport = createAsyncThunk('report/exportXeroInvoiceDetailReport', async (data, { dispatch }) => {
    const response = await exportXeroInvoiceDetailReportApi(data);
    return response.response;
});


const vogaclosetReportAdapter = createEntityAdapter({});

export const { selectAll: selectVogaclosetReport, selectById: selectVogaclosetReportById } = vogaclosetReportAdapter.getSelectors(
    state => state.report
);

const vogaclosetReportSlice = createSlice({
    name: 'vogaclosetReport',
    initialState: vogaclosetReportAdapter.getInitialState({
        id: null,
        settings: {
            partners: [],
            deliveryPartners: [],
            shippingTypes: [],
            currencies: [],
        },
        filters: {
            startDate: null,
            endDate: null,
            partner: null
        },
        invoiceLists: [],
        invoiceTableRow: 0,
        invoiceTotalSummary: null,
    }),
    reducers: {
        setSettings: (state, action) => {
            state.settings.partners = action.payload.partners;
            state.settings.deliveryPartners = action.payload.delivery_partners;
            state.settings.shippingTypes = action.payload.shipping_types;
            state.settings.currencies = action.payload.currencies;
        },
        setFilter: (state, action) => {
            state.filters = action.payload;
        },
        setInvoicesData: (state, action) => {
            state.invoiceLists = action.payload.data;
            state.invoiceTableRow = action.payload.total;
            // state.invoiceTotalSummary = action.payload.total_summary;
        },
    },
    extraReducers: {
        // [getVogaclosetReport.fulfilled]: vogaclosetReportAdapter.setAll
    }
});

export const {
    setSettings,
    setFilter,
    setInvoicesData,
} = vogaclosetReportSlice.actions;

export default vogaclosetReportSlice.reducer;